import { Status } from 'ui-widgets';
import { config } from '../../config';
import {
  setRepresentatives,
  setStatus,
} from '../../redux/sliceCreators/representativesSlice';
import { AppDispatch } from '../../redux/store';
import { client } from '../http';

export const getRepresentatives =
  (productId: string, manufacturerId?: string) =>
  async (dispatch: AppDispatch) => {
    try {
      const params = new URLSearchParams();
      params.append('product_id', productId);
      if (manufacturerId) {
        params.append('manufacturer_id', manufacturerId);
      }

      dispatch(setStatus({ productId, status: Status.LOADING }));

      const { data } = await client.get(config.endpoints.getRepresentatives, {
        params,
      });

      dispatch(setRepresentatives(data));
      dispatch(setStatus({ productId, status: Status.LOADED }));

      return data;
    } catch (error) {
      console.log('error getRepresentatives', error);
      dispatch(setStatus({ productId, status: Status.ERROR }));
    }
  };
